QuestionsList = require 'components/scope/outcomes/questions_list'
QuestionGroupTitle = require 'components/scope/outcomes/question_group_title'
FinishedOutcomesTable = require 'components/scope/outcomes/finished_outcomes_table'
CustomRenderMixin = require 'components/mixins/custom_render_mixin'

QuestionGroupForFinished = createReactClass
  displayName: 'QuestionGroupForFinished'
  mixins: [CustomRenderMixin]
  propTypes:
    data: PropTypes.object.isRequired
    gIndex: PropTypes.number.isRequired

  render: ->
    name = @props.data.get 'name'
    questions = @props.data.get 'questions'
    outcomes = @props.data.get 'outcomes'

    <div className='question-group'>
      <QuestionGroupTitle text={name} />
      <QuestionsList questions={questions} groupName={name} />
      <FinishedOutcomesTable
        outcomes={outcomes}
        membersMap={@props.membersMap}
        gIndex={@props.gIndex}
        readOnly={@props.readOnly}
        changeOutcomeImportance={@props.onChangeOutcomeImportance}
        showingComments={@props.showingComments}
        onCommentToggle={@props.onCommentToggle}
      />
    </div>

module.exports = QuestionGroupForFinished
